<template>
  <div class="max-racing-result-history">
    <Row type="flex">
      <Col id="max-racing-history-player" class="max-racing-history-bar">
        {{$t('general.Big')}} -
        <span>{{ this.b_percentage }}%</span>
      </Col>
      <Col id="max-racing-history-player" class="max-racing-history-bar">
        {{$t('general.Small')}} -
        <span>{{ this.s_percentage }}%</span>
      </Col>
      <Col id="max-racing-history-player" class="max-racing-history-bar">
        11 -
        <span>{{ this.t_percentage }}%</span>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col
        class="max-racing-history-trend-lot-col"
        v-for="(col, index) in this.newArr"
        :key="index"
      >
        <div
          class="max-racing-history-trend-lot-cell"
          :class="getBS(cell[3])"
          v-for="(cell, index) in col"
          :key="index"
        >
          <max-racing-history-popper
            :game="game"
            :cell-data="cell"
            :game-code="gameCode"
            :game-id="gameId"
          >{{ getBS(cell[3]) }}</max-racing-history-popper>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import { Row, Col } from "iview";
import { TimelineMax } from "gsap";
import MaxRacingHistoryPopper from "../widgets/MaxRacingHistoryPopper";

export default {
  props: ["historicalData", "game", "gameCode", "gameId"],
  components: {
    Row,
    Col,
    MaxRacingHistoryPopper
  },
  data() {
    return {
      tempArr: [],
      newArr: [],
      totalRow: 18,
      b_percentage: 0,
      s_percentage: 0,
      t_percentage: 0
    };
  },
  methods: {
    getBS(value) {
      if (value == 6) return "B";
      else if (value == 7) return "S";
      else return "11";
    },
    triggerBlinkingEffect() {
      this.$nextTick(() => {
        let animationTl = new TimelineMax();

        animationTl
          .to(
            "#game-" +
              this.gameId +
              " .max-racing-history-trend-lot-col:last-of-type .max-racing-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 0
            }
          )
          .to(
            "#game-" +
              this.gameId +
              " .max-racing-history-trend-lot-col:last-of-type .max-racing-history-trend-lot-cell:last-of-type",
            0.5,
            {
              opacity: 1
            }
          );
        animationTl.repeat(4);
      });
    }
  },
  watch: {
    historicalData() {
      this.tempArr = [];
      let tempData = [...this.historicalData];
      let index = 0;
      this.b_percentage = 0;
      this.s_percentage = 0;
      this.t_percentage = 0;
      let champion = 0;

      for (var i = 0; i < tempData.length; i++) {
        let temp = [];

        if (tempData[i]["champion"].charAt(0) == 1) {
          if (tempData[i]["champion"].charAt(1) == 0) {
            champion = 10;
          } else {
            champion = 1;
          }
        } else {
          champion = tempData[i]["champion"].charAt(0);
        }

        if (tempData[i]["cru_bs"] == 6) this.b_percentage++;
        if (tempData[i]["cru_bs"] == 7) this.s_percentage++;
        if (tempData[i]["cru_bs"] == 99) this.t_percentage++;

        temp.push(champion);
        temp.push(tempData[i]["c_bs"], tempData[i]["c_oe"]);
        temp.push(tempData[i]["cru_bs"], tempData[i]["cru_oe"]);
        temp.push(tempData[i]["group"], tempData[i]["runnerup"]);
        temp.push(tempData[i]["draw_no"], tempData[i]["draw_datetime"]);
        this.tempArr.push(temp);
      }

      this.tempArr.reverse();

      (index = 3),
        (this.newArr = this.tempArr.reduce((result, data, i, array) => {
          if (
            !array[i - 1] ||
            data[index] !== array[i - 1][index] ||
            result[result.length - 1].length === 5
          )
            result.push([]);
          result[result.length - 1].push(data);
          return result;
        }, []));

      this.newArr.reverse();
      this.newArr.splice(this.totalRow);
      this.newArr.reverse();
      this.triggerBlinkingEffect();
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.max-racing-history-trend-lot-cell {
  color: #ffffff;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 100px;
  margin-top: 6px;
  cursor: pointer;
  overflow: hidden;
}

.max-racing-history-trend-lot-cell.B {
  background: #fa594f;
}

.max-racing-history-trend-lot-cell.S {
  background: #3e7ffd;
}

.max-racing-history-trend-lot-cell.\31\31 {
  background: #2e4053;
}
</style>

<style lang="scss">
.max-racing-history-bar {
  flex: 0.2 1 auto;
  color: rgb(0, 0, 0);
  background-color: rgb(239, 242, 248);
  padding: 4px 12px;
  margin: 2px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
</style>
